import React from "react";

// Styles
import styled from "styled-components";

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";

export default function Spinner(props) {
  return (
    <Spin>
      <div className="spinner" />
    </Spin>
  );
}

export function SmallSpinner(props) {
  return (
    <SmallSpin>
      <div className="spinner" />
    </SmallSpin>
  );
}
const SmallSpin = styled.div`
  padding: 3px;
  .spinner {
    margin: auto;
    height: 18px;
    width: 18px;
    animation: rotate 0.8s infinite linear;
    border: 4px solid white;
    border-right-color: transparent;
    border-radius: 50%;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const Spin = styled.div`
  padding: 50px;
  .spinner {
    margin: auto;
    height: 24px;
    width: 24px;
    animation: rotate 0.8s infinite linear;
    border: 8px solid #333;
    border-right-color: transparent;
    border-radius: 50%;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
